import { useCallback, useEffect, useState } from "react";
import { getPropertyDetail } from "../services/midpointApi";
import { mapPropertyDetailResponse } from "../utils/mapPropertyDetailResponse";

export function usePropertyDetail(propertyId) {
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(Boolean(propertyId));
  const [error, setError] = useState("");
  const [notFound, setNotFound] = useState(false);

  const load = useCallback(async () => {
    if (!propertyId) {
      setProperty(null);
      setLoading(false);
      setNotFound(true);
      return;
    }

    setLoading(true);
    setError("");
    setNotFound(false);

    try {
      const response = await getPropertyDetail(propertyId);
      setProperty(mapPropertyDetailResponse(response));
    } catch (err) {
      setProperty(null);
      if (err.status === 404) {
        setNotFound(true);
        setError("");
      } else {
        setNotFound(false);
        setError(err.message || "Unable to load property details.");
      }
    } finally {
      setLoading(false);
    }
  }, [propertyId]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    property,
    loading,
    error,
    notFound,
    reload: load,
  };
}
